import { useDroppable } from '@dnd-kit/core';
import { StyledDroppableGap } from './DroppableGap.styled';

export default function DroppableGap({ id, children }) {
  const { setNodeRef, isOver } = useDroppable({
    id,
  });
  return (
    <StyledDroppableGap className={isOver ? ' over' : ''} ref={setNodeRef}>
      {children}
    </StyledDroppableGap>
  );
}
